import { render, staticRenderFns } from "./CheckupExportModal.vue?vue&type=template&id=1d48000c&scoped=true"
import script from "./CheckupExportModal.vue?vue&type=script&lang=js"
export * from "./CheckupExportModal.vue?vue&type=script&lang=js"
import style0 from "./CheckupExportModal.vue?vue&type=style&index=0&id=1d48000c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48000c",
  null
  
)

export default component.exports